import { render } from "./IconEmail.vue?vue&type=template&id=24a9ce87&scoped=true"
const script = {}

import "./IconEmail.vue?vue&type=style&index=0&id=24a9ce87&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a9ce87"]])

export default __exports__